var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d71a819551e0b12e08751d9413e5f859b68a044b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["niche-crm-web-prod@niche-mates"]={id:"d71a819551e0b12e08751d9413e5f859b68a044b"};
      